<template>
  <div id="index" v-cloak>
     <div v-if="idloading">
      <div class="spinner-box">
       <img src="@/assets/img/loadding_pc.gif" alt="">
      </div>
    </div>
    <div v-else class="visible-xs min_index">
      <!-- 头部 -->
      <MinHeader></MinHeader>
      <!-- <Hezuo></Hezuo> -->

      <!-- banner -->
      <div class="banner banner_swiper1 swiper-container" v-if="banner_arr.length>0">
        <!-- 左右滑动按钮 -->
        <div class="swiper-wrapper">
          <div class="swiper_item swiper-slide" v-for="(liem,index) in banner_arr" :key="index"
            @click.stop="bannerFun(liem)" :style="{backgroundImage: 'url('+IMG_URL+liem.url+')'}">
            <a class="a_have" @click.stop="bannerFun(liem)"></a>
          </div>
        </div>
        <div class="swiper-pagination1 flex_center"></div>
      </div>
      <!-- 模块选择 -->
      <div class="selectBox flex_between">
        <div class="LiveTitle" @click="selectBox_index = 1" :class="{'bule' : selectBox_index == 1}">Live</div>
        <div class="backTitle" @click="selectBox_index = 2" :class="{'bule' : selectBox_index == 2}">精彩回放</div>
      </div>
      <div class="flex_between arrangement">
        <div class="flex_center arrangement_li" @click.stop="arrangement_index = 2">
          <i v-if="arrangement_index == 2"><img src="@/assets/img/partyT.png" alt=""></i>
          <i v-else><img src="@/assets/img/party.png" alt=""></i>
        </div>
        <div class="flex_center arrangement_li" @click.stop="arrangement_index = 1">
          <i v-if="arrangement_index == 1"><img src="@/assets/img/crossT.png" alt=""></i>
          <i v-else><img src="@/assets/img/cross.png" alt=""></i>
        </div>

      </div>
      <!-- 模块内容 -->
      <div class="video_content">
        <!-- Live -->
        <div class="main" v-if="live_arr.length>0">
          <div class="video_ul" v-if="arrangement_index == 2">

            <div class="video_li" v-for="liem in live_arr" @click="details(liem)">
              <div class="video_head flex_between">
                <div class="video_li_title flex_start">
                  <div class="title">{{liem.name}}</div>
                  <div class="tag flex_center cheng" v-if="selectBox_index == 2">回放</div>
                  <div class="tag flex_center" v-if="selectBox_index == 1">直播</div>
                </div>
                <div class="video_time flex_start">
                  <img class="video_time_img" src="@/assets/img/video_icon.png" alt>
                  <span>直播时间：{{liem.start_time}} {{liem.time}}</span>
                </div>
              </div>
              <div class="video_center">
                <img class="touxiao" v-if="liem.image" :src="IMG_URL+liem.image" alt>
                <!-- <img class="touxiao" v-else src="./img/tuzi.png" alt=""> -->
                <div class="video_name">{{liem.doctor}}</div>
                <div class="tag_title flex_start">
                  <span>{{liem.position}}</span>
                  <span>{{liem.hospital}}</span>
                </div>
              </div>
            </div>

          </div>
          <div class="video_ul landscape" v-else>
            <div class="landscape_li flex_between" v-for="liem in live_arr" 
            @click="details(liem)">
              <div class="video_li_left clamp2">
                <div class="tag flex_center cheng" v-if="selectBox_index == 2">回放</div>
                <div class="tag flex_center" v-if="selectBox_index == 1">直播</div>
                {{liem.name}}
                <!-- :{{liem.doctor}} -->
              </div>
              <i class="video_li_img" v-if="liem.cover"><img :src="liem.cover?liem.cover:'@/assets/img/app_logo.png'" alt=""></i>
              <i class="video_li_img" v-else><img src="@/assets/img/app_logo.png" alt=""></i>
            </div>
          </div>
        </div>
        <div class="complete" v-else-if="is_request">
          <div class="claloadding">
            <div>
              <img
                src="@/assets/img/kkry_pc.gif"
                alt=""
              >
            </div>
            <div>空空如也...</div>
          </div>
        </div>
        <div class="complete" v-else>
          加载中
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <LoginPrompt @promptFun="promptFun" ref="prompt"></LoginPrompt>
      <!-- 尾部 -->
      <MinFooter :headIndex="3"></MinFooter>

      <!-- <div class="flex_center" style="opacity: .4;" @click.stop="removeFun">清除缓存</div> -->
    </div>
  </div>
</template>

<script>
  import MinHeader from "@/components/m_assembly/MinHeader.vue"; //头部模块
  import MinFooter from "@/components/m_assembly/MinFooter.vue"; //尾部模块
  import LoginPrompt from "@/components/assembly/LoginPrompt.vue"; //注册弹窗模块
  import "@/assets/js/swiper.animate1.0.3.min.js";
  import "@/assets/css/animate.min.css";
  import "@/assets/css/video-js.min.css";
import Hezuo from '@/components/tool/m_hezuo.vue'

  export default {
    name: "m_index",
    data() {
      return {
        IMG_URL: this.$IMG_URL,
        banner_arr: [], //背景图片
        arrangement_index: 2,//排序 1竖排 2方排
        selectBox_index: 0, //切换index
        is_pc: true, //是否是pc端打开
        live_arr: [], //直播数组
        is_request: false,
        idloading:true
      };
    },
    computed: {},
    components: {
      MinHeader,
      MinFooter, LoginPrompt,Hezuo
    },
    watch: {
      selectBox_index: function (eve, liem) {
        if (eve == 1) {
          this.getLive();
        } else {
          this.playback();
        }
      }
    },
    methods: {
      promptFun() {//提示弹窗回调
        this.$router.push("/m_registered");
      },
      is_judge(liem) {//判断登录
        if (liem.power == 0) {
          return true
        }
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.prompt.popupFun();
          return false;
        }
        if ((this.USER().plus < 2 && liem.power == 2) || (this.USER().plus == 0 && liem.power == 1)) {
          layer.open({
            content: this.promptPermissions,
            time: true,
            skin: "msg"
          });
          return false
        }
        return true;
      },
      bannerFun(liem) {//轮播跳转
        if (!this.is_judge(liem.detail)) {
          return false;
        }
        if (this._isMobile()) {
          // alert("手机端");
          if (liem.detail.ive_type == 0) {//直播
            this.$router.push({ path: './min_move', query: { id: liem.live_id, url: liem.detail.live_url, power: liem.detail.power } });
          } else {
            this.$router.push({ path: './min_record', query: { id: liem.live_id, url: liem.detail.live_url, power: liem.detail.power } });
          }
        } else {
          // alert("pc端");
          if (liem.detail.ive_type == 0) {//直播
            this.$router.push({ path: './pc_move', query: { id: liem.live_id, url: liem.play_url, power: liem.power } });
          } else {
            this.$router.push({ path: './pc_record', query: { id: liem.live_id, url: liem.play_url, power: liem.power } });
          }
        }
      },
      removeFun() {//退出登录
        this.REMOVE_USER();
        layer.open({
          content: '退出成功'
          , time: 1
          , skin: 'msg'
        });
        // this.GET_Token();
      },
      details(liem) {

        if (!this.is_judge(liem)) {
          return false;
        }
        let id = liem.id;
        let record_url = liem.record_url;
        if (this._isMobile()) {
          // alert("手机端");
          if (this.selectBox_index == 1) {//直播
            this.$router.push({ path: 'min_move', query: { id: id, url: record_url, power: liem.power } });
          } else {
            this.$router.push({ path: 'min_record', query: { id: id, url: record_url, power: liem.power } });
          }
        } else {
          // alert("pc端");
          if (this.selectBox_index == 1) {//直播
            this.$router.push({ path: 'pc_move', query: { id: id, url: record_url, power: liem.power } });
          } else {
            this.$router.push({ path: 'pc_record', query: { id: id, url: record_url, power: liem.power } });
          }
        }

      },
      getLive() {
        //获取直播列表
        let that = this;
        this.is_request = false;
        this.$get("live_lists", {}).then(res => {
          that.is_request = true;
          that.live_arr = res.data;
        });
      },
      playback() {
        //获取录播列表
        let that = this;
        this.is_request = false;
        this.$get("record_lists", {}).then(res => {
          that.is_request = true;
          that.live_arr = res.data;
        });
      },
      swiperFun() {
        //实例swiper
        new Swiper(".banner_swiper1", {
          pagination: ".swiper-pagination1",
          slidesPerView: 1,
          initialSlide: 0,
          autoplay: 2000,
          centeredSlides: true,
          paginationClickable: true,
          spaceBetween: 0,
          // loop: true
        });
      },
      request() {
        //获取banner
        let that = this;
        this.$get("banner_lists", { name: 1 }).then(res => {
          that.banner_arr = res.data;
          that.$nextTick(function () {
            that.swiperFun();
          });
        });
      },
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      // 判断完毕后加载样式
      setActiveStyleSheet(filename) {
        document.write("<link href=" + filename + " rel=stylesheet>");
      },

    },
      activated () {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
    mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;

      this.idloading=false
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      }
      if (this.GetRequest().code) {
        window.location.href = this.$VIEW_URL;
      }
      document.title = '麻醉眼界';
      this.request();
      if(this.$route.query.id){
      this.selectBox_index = this.$route.query.id;

      }else{
      this.selectBox_index = 1;

      }
      let that = this;
      // this.GET_Token({
      //   success:function(eve){
      //     that.getShare();
      //   }
      // })
      that.getShare();
      if (this._isMobile()) {
        // alert("手机端");
          this.$router.replace('/m_index');
      } else {
        // alert("pc端");
        this.$router.replace("/index");
      }


      // window.onload = function () {
      //     var w = document.body.clientWidth; //获取屏幕宽度
      //     // 这里*100 是为了取整数
      //     var x = parseInt((w * 100) / 375 * 10) / 10; //获取任意屏幕上的根节点字体大小
      //     document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
      //     //监听屏幕宽度变化
      //     window.onresize = function () {
      //         var w = document.body.clientWidth; //获取屏幕宽度
      //         var x = parseInt((w * 100) / 375 * 10) / 10;; //获取任意屏幕上的根节点字体大小
      //         document.getElementsByTagName('html')[0].style.fontSize = x + 'px';
      //     }
      // }
    }
  };
</script>

<style scoped>
  html,
  body {
    max-width: 100vw;
  }

  .visible-xs {
    width: 100vw;
    overflow: hidden;
    padding-top: 0rem;
  }

  .topBox {
    height: 4.5rem;
    background: #fff;
    padding: 0 1.5rem;
  }

  .isshow {
    display: none;
  }

  .topBox img {
    width: 12.7rem;
  }

  .topBox .goWebsite {
    background-color: #db414e;
    height: 2rem;
    padding: 0 1rem;
    font-size: 1.2rem;
    color: #fff;
    border-radius: 0.5rem;
    cursor: pointer;
    line-height: 1em;
  }

  .banner_swiper1 {
    /* height: 19.5rem; */
    height: calc(100vw * .5);
    width: 100%;
    
    position: relative;
  }

  .banner_swiper1 .swiper_item {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }

  .banner .swiper-pagination1 {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }

  .banner .swiper-pagination1 .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: rgba(0, 0, 0, 1);
    transition: all 0.5s ease;
    margin: 0 0.2rem;
  }

  .banner .swiper-pagination1 .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 30px;
    height: 12px;
    border-radius: 6px;
    background: #fff;
  }

  .selectBox {
    padding: 1.5rem 1.6rem;
    width: calc(100% - 3.2rem);
  }

  .selectBox div {
    display: inline-block;
    width: calc(50% - 0.7rem);
    height: 4rem;
    text-align: center;
    line-height: 4rem;
    cursor: pointer;
    border-radius: 3px;
    background-color: #f4f4f4;
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .arrangement {
    height: 3.5rem;
    background: #f4f4f4;
    border-radius: .6rem;
    margin: 1rem auto;
    width: calc(100% - 3rem);
  }

  .arrangement>.arrangement_li {
    width: 50%;
    position: relative;
    cursor: pointer;
  }

  .arrangement>.arrangement_li:last-child:after {
    width: .3rem;
    height: 2.7rem;
    background: #DBDBDB;
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .arrangement>.arrangement_li i {
    width: 2rem;
  }


  .content {
    padding: 0 2rem;
  }

  .content .panel-default>.panel-heading {
    background-color: #ccc;
  }

  .selectBox .bule {
    background-color: #f24d5b;
    color: #fff;
    position: relative;
  }

  .selectBox .bule::after {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    content: "";
    width: 0;
    height: 0;
    border-width: 0.8rem;
    border-style: solid;
    border-color: #f24d5b transparent transparent transparent;
  }

  .video_content {
    padding: 1rem 0;
  }

  .video_ul {
    padding: 0 1.5rem;
  }

  .video_ul .video_li {
    margin-bottom: 1rem;
    background: #fff;
    box-shadow: 0.35rem 0 2.3rem rgba(71, 71, 71, 0.17);
    border-radius: 0.5rem;
    padding: 0 2.1rem;
    min-height: 16.05rem;

  }

  .video_ul .video_li .video_li_title {
    width: 100%;
    align-items: center;
  }

  .video_ul .video_li .video_li_title .title {
    max-width: calc(100% - 4rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.8rem;
    font-weight: bold;
  }

  .video_ul .video_li .video_li_title .tag {
    margin-left: 0.9rem;
    width: 3rem;
    height: 1.55rem;
    border-radius: 0.2rem;
    background: #f24d5b;
    color: #ffffff;
    font-size: 1rem;
    line-height: 1em;
  }
  .video_ul .video_li .video_li_title .tag.cheng{
    background: #EE8A60;
  }
  .video_ul .video_li .video_head {
    padding: 1.8rem 0;
    height:6rem;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    border-bottom: 0.05rem dashed #e4e4e4;
  }

  .video_ul .video_li .video_head .video_time>.video_time_img {
    width: 1.7rem;
    height: 1.7rem;
    margin-right: 0.55rem;
  }

  .video_ul .video_li .video_head .video_time {
    width: 100%;
  }

  .video_ul .video_li .video_head .video_time>span {
    font-size: 1.12rem;
    flex: 1;
    display: block;
    color: #818a92;
    max-width: calc(100% - 2.5rem);
  }

  .video_ul.landscape {
    width: calc(100% - 3rem);
    margin: 0 auto;
    background: #fff;
    box-shadow: 0.35rem 0 2.3rem rgba(71, 71, 71, 0.17);
    padding: 0 1rem;
    border-radius: .6rem;
  }

  .video_ul.landscape .landscape_li {
    border-bottom: .05rem solid #F2F2F2;
    padding: 1.6rem 0;
    height: 6.5rem;
  }

  .video_ul.landscape .landscape_li .video_li_left {
    flex: 1;
    margin-right: 1rem;
    text-align: left;
    height: 100%;
    line-height: 1.8em;
    font-size: 1.7rem;
    color: #000;
    font-weight: bold;
  }

  .video_ul.landscape .landscape_li .video_li_left>.tag {
    margin-right: 0.4rem;
    width: 3.8rem;
    height: 1.8rem;
    border-radius: 0.4rem;
    background: #f24d5b;
    color: #ffffff;
    font-size: 1rem;
    line-height: 1em;
    display: inline-flex;
    transform: translateY(-.2rem);
  }
  .video_ul.landscape .landscape_li .video_li_left>.tag.cheng{
    background: #EE8A60;
  }
  .video_ul.landscape .landscape_li .video_li_img {
    width: 8rem;
    height: 100%;
    overflow: hidden;
  }

  .video_center {
    align-items: center;
    min-height: calc(100% - 9rem);
    padding-bottom: 1.05rem;
    text-align: left;
  }

  .video_center>.touxiao {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    margin-right: 0.8rem;
  }

  .video_center .video_name {
    font-size: 1.2rem;
    margin-top: 1rem;
    color: #525963;
  }

  .video_center .tag_title {
    margin-left: 1.8rem;
  }

  .video_center .tag_title>span {
    font-size: 1.2rem;
    color: #525963;
    margin-right: 10px;
    white-space: nowrap;
  }

  .Live {
    display: flex;
    flex-direction: column;
  }

  .Live li {
    text-align: center;
    padding: 2rem 10px;
    border-radius: 5px;
    margin: 1rem;
    display: flex;
    background-color: rgba(242, 242, 242, 1);
    align-content: center;
    justify-content: center;
  }

  .Live li .bigTitle {
    font-size: 1.5rem;
    font-weight: 600;
    display: block;
    line-height: 1.7rem;
    margin-bottom: 5px;
  }

  .Live li .title {
    width: 26rem;
    display: inline-block;
    text-align: left;
  }

  .Live li .info {
    color: #aeaeae;
  }

  .Live li .playTime {
    width: 10rem;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
  }

  .Live li .play {
    font-size: 2rem;
    display: block;
  }

  .playBox {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(242, 242, 242, 0.5);
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
  }

  .Box {
    width: 100%;
    background-color: #ccc;
    position: relative;
    display: flex;
    align-items: center;
  }

  .Box .closePlay {
    float: right;
    margin: 10px;
    color: #fff;
    cursor: pointer;
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
  }

  .foot {
    text-align: center;
    height: 6rem;
    border-top: 0.1rem solid rgba(247, 244, 248, 0.8);
  }

  .foot a {
    color: #000;
  }
  .claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_index.vue